import { ComponentPropsWithoutRef } from 'react';
import { maskWholeNumber } from '@givebutter/util';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { twMerge } from 'tailwind-merge';

interface LetterExcludedRecipientCountsProps extends ComponentPropsWithoutRef<'div'> {}

const LetterExcludedRecipientCounts = (props: LetterExcludedRecipientCountsProps) => {
    const { className = '', ...restProps } = props;
    const { data: letter } = useCurrentLetter();

    return (
        <div className={twMerge('text-sm text-gray-600', className)} {...restProps}>
            {letter.excluded_recipient_counts?.missing_household !== 0 && (
                <div>
                    {maskWholeNumber(letter.excluded_recipient_counts?.missing_household)}{' '}
                    {letter.excluded_recipient_counts?.missing_household === 1
                        ? 'contact is not a household member'
                        : 'contacts are not household members'}
                </div>
            )}
            {letter.excluded_recipient_counts?.missing_address !== 0 && (
                <div>
                    {maskWholeNumber(letter.excluded_recipient_counts?.missing_address)}{' '}
                    {letter.excluded_recipient_counts?.missing_address === 1
                        ? 'contact does not have an address or the address is invalid'
                        : 'contacts do not have addresses or have invalid addresses'}
                </div>
            )}
            {letter.excluded_recipient_counts?.outside_supported_countries !== 0 && (
                <div>
                    {maskWholeNumber(letter.excluded_recipient_counts?.outside_supported_countries)}{' '}
                    {letter.excluded_recipient_counts?.outside_supported_countries === 1
                        ? 'contact does not have an address in the United States'
                        : 'contacts do not have addresses in the United States'}
                </div>
            )}
            {letter.excluded_recipient_counts?.missing_merge_field_values !== 0 && (
                <div>
                    {maskWholeNumber(letter.excluded_recipient_counts?.missing_merge_field_values)}{' '}
                    {letter.excluded_recipient_counts?.missing_merge_field_values === 1
                        ? 'contact has missing merge fields'
                        : 'contacts have missing merge fields'}
                </div>
            )}
            {letter.excluded_recipient_counts?.excluded_during_personalization !== 0 && (
                <div>
                    {maskWholeNumber(
                        letter.excluded_recipient_counts?.excluded_during_personalization,
                    )}{' '}
                    {letter.excluded_recipient_counts?.excluded_during_personalization === 1
                        ? 'contact was excluded during personalization'
                        : 'contacts were excluded during personalization'}
                </div>
            )}
        </div>
    );
};

export { LetterExcludedRecipientCounts };
